import { setSyncStatus, getSyncStatus } from '../stores/sync.svelte.ts';

let supabase: any = null;
const supabaseModule = '@supabase/supabase-js' as string;

export async function initSync(supabaseUrl: string, supabaseKey: string): Promise<void> {
  try {
    const mod = await import(/* @vite-ignore */ supabaseModule);
    supabase = mod.createClient(supabaseUrl, supabaseKey);
    setSyncStatus({ connected: true });
  } catch {
    console.warn('Supabase not installed. Cloud sync unavailable.');
    setSyncStatus({ error: 'Supabase not installed' });
  }
}

export async function signUp(email: string): Promise<{ error: string | null }> {
  if (!supabase) return { error: 'Sync not initialized' };
  const { error } = await supabase.auth.signUp({ email });
  if (error) return { error: error.message };
  return { error: null };
}

export async function signInMagicLink(email: string): Promise<{ error: string | null }> {
  if (!supabase) return { error: 'Sync not initialized' };
  const { error } = await supabase.auth.signInWithOtp({ email });
  if (error) return { error: error.message };
  return { error: null };
}

export async function createSyncGroup(): Promise<string | null> {
  const code = Math.random().toString(36).substring(2, 8).toUpperCase();
  setSyncStatus({ syncGroupId: code });
  return code;
}

export async function joinSyncGroup(code: string): Promise<{ error: string | null }> {
  setSyncStatus({ syncGroupId: code });
  return { error: null };
}

export async function syncToCloud(): Promise<void> {
  setSyncStatus({ syncing: true });
  // Placeholder: push records where updatedAt > syncedAt
  setSyncStatus({ syncing: false, lastSyncAt: Date.now() });
}

export async function syncFromCloud(): Promise<void> {
  setSyncStatus({ syncing: true });
  // Placeholder: pull records from Supabase newer than local syncedAt
  setSyncStatus({ syncing: false, lastSyncAt: Date.now() });
}
